<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ modalTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-describedby="modal-title"
    (click)="dismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <h6>
    {{ modalBody }}
  </h6>
</div>
<div class="modal-footer">
  <button
    ngbAutofocus
    type="button"
    class="btn btn-outline-primary w-150"
    *ngIf="isRecarding() && modalCancelButtonText != ''"
    (click)="cancelClick()"
  >
    {{ modalCancelButtonText }}
  </button>
  <button
    type="button"
    class="btn btn-outline-secondary w-150"
    *ngIf="!isRecarding() && modalCancelButtonText != ''"
    (click)="cancelClick()"
  >
    {{ modalCancelButtonText }}
  </button>
  <button
    ngbAutofocus
    type="button"
    class="btn btn-primary w-150"
    *ngIf="!isRecarding()"
    (click)="okClick()"
  >
    {{ modalOkButtonText }}
  </button>
  <button
    type="button"
    class="btn btn-primary w-150"
    *ngIf="isRecarding()"
    (click)="okClick()"
  >
    {{ modalOkButtonText }}
  </button>
</div>
